import PublicEditablePage from './PublicEditablePage';

const TermsPage = () => (
  <PublicEditablePage
    slug="terms"
    fallbackTitle="Terms of Service"
    seo={{
      title: 'Terms of Service',
      description: 'The terms and conditions that apply when you purchase from BlueSpark Australia — consumer guarantees, warranty, returns, refunds, and liability.',
      canonical: '/terms',
    }}
  />
);

export default TermsPage;
